import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
    const PolicyOptionsList = Loadable(
  lazy(() =>
    import("./PolicyOptionsList").then(({ PolicyOptionsList }) => ({
      default: PolicyOptionsList,
    }))
  )
);
const PolicyOptions = Loadable(
  lazy(() =>
    import("./PolicyOptions").then(({ PolicyOptions }) => ({
      default: PolicyOptions,
    }))
  )
);
export const policyOptionsRoutes = [
  {
    path: "/settings/policy-options",
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleKeys={[]}>
        <PolicyOptionsList />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/settings/policy-options/:policyType",
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleKeys={[]}>
        <PolicyOptions />
      </AuthorizedRoute>
    ),
  },
];
